import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_2 = { class: "p-field p-col-4" }
const _hoisted_3 = { class: "p-float-label" }
const _hoisted_4 = {
  for: "label",
  class: "kn-material-input-label"
}
const _hoisted_5 = { class: "p-field p-col-4" }
const _hoisted_6 = { class: "p-float-label" }
const _hoisted_7 = {
  for: "name",
  class: "kn-material-input-label"
}
const _hoisted_8 = { class: "p-field p-col-4" }
const _hoisted_9 = { class: "p-float-label" }
const _hoisted_10 = {
  for: "type",
  class: "kn-material-input-label"
}
const _hoisted_11 = { class: "p-field p-col-8" }
const _hoisted_12 = { class: "p-float-label" }
const _hoisted_13 = {
  for: "description",
  class: "kn-material-input-label"
}
const _hoisted_14 = { class: "p-field p-col-4" }
const _hoisted_15 = { class: "p-float-label" }
const _hoisted_16 = {
  for: "description",
  class: "kn-material-input-label"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")
  const _component_KnValidationMessages = _resolveComponent("KnValidationMessages")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_MultiSelect = _resolveComponent("MultiSelect")
  const _component_Card = _resolveComponent("Card")

  return (_openBlock(), _createBlock(_component_Card, null, {
    content: _withCtx(() => [
      _createVNode("form", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("span", _hoisted_3, [
            _createVNode(_component_InputText, {
              id: "label",
              class: ["kn-material-input", {
                                'p-invalid': _ctx.v$.driver.label.$invalid && _ctx.v$.driver.label.$dirty
                            }],
              type: "text",
              modelValue: _ctx.v$.driver.label.$model,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.v$.driver.label.$model = $event)),
              maxLength: "20",
              onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.v$.driver.label.$touch())),
              onChange: _ctx.setDirty
            }, null, 8, ["modelValue", "class", "onChange"]),
            _createVNode("label", _hoisted_4, _toDisplayString(_ctx.$t('common.label')) + " * ", 1)
          ]),
          _createVNode(_component_KnValidationMessages, {
            class: "p-mt-1",
            vComp: _ctx.v$.driver.label,
            additionalTranslateParams: { fieldName: _ctx.$t('common.label') }
          }, null, 8, ["vComp", "additionalTranslateParams"])
        ]),
        _createVNode("div", _hoisted_5, [
          _createVNode("span", _hoisted_6, [
            _createVNode(_component_InputText, {
              id: "name",
              class: ["kn-material-input", {
                                'p-invalid': _ctx.v$.driver.name.$invalid && _ctx.v$.driver.name.$dirty
                            }],
              type: "text",
              modelValue: _ctx.v$.driver.name.$model,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.v$.driver.name.$model = $event)),
              maxLength: "20",
              onBlur: _cache[4] || (_cache[4] = ($event: any) => (_ctx.v$.driver.name.$touch())),
              onChange: _ctx.setDirty
            }, null, 8, ["modelValue", "class", "onChange"]),
            _createVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('common.name')) + " * ", 1)
          ]),
          _createVNode(_component_KnValidationMessages, {
            class: "p-mt-1",
            vComp: _ctx.v$.driver.name,
            additionalTranslateParams: { fieldName: _ctx.$t('common.name') }
          }, null, 8, ["vComp", "additionalTranslateParams"])
        ]),
        _createVNode("div", _hoisted_8, [
          _createVNode("span", _hoisted_9, [
            _createVNode(_component_Dropdown, {
              id: "type",
              class: ["kn-material-input", {
                                'p-invalid': _ctx.v$.driver.type.$invalid && _ctx.v$.driver.type.$dirty
                            }],
              modelValue: _ctx.v$.driver.type.$model,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.v$.driver.type.$model = $event)),
              options: _ctx.types,
              optionValue: "VALUE_CD",
              optionLabel: "VALUE_NM",
              onBlur: _cache[6] || (_cache[6] = ($event: any) => (_ctx.v$.driver.type.$touch())),
              onChange: _ctx.setDirty
            }, null, 8, ["modelValue", "options", "class", "onChange"]),
            _createVNode("label", _hoisted_10, _toDisplayString(_ctx.$t('common.type')) + " * ", 1)
          ]),
          _createVNode(_component_KnValidationMessages, {
            class: "p-mt-1",
            vComp: _ctx.v$.driver.type,
            additionalTranslateParams: { fieldName: _ctx.$t('common.type') }
          }, null, 8, ["vComp", "additionalTranslateParams"])
        ]),
        _createVNode("div", _hoisted_11, [
          _createVNode("span", _hoisted_12, [
            _createVNode(_component_InputText, {
              id: "description",
              class: "kn-material-input",
              type: "text",
              modelValue: _ctx.driver.description,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.driver.description = $event)),
              onChange: _ctx.setDirty,
              maxLength: "100"
            }, null, 8, ["modelValue", "onChange"]),
            _createVNode("label", _hoisted_13, _toDisplayString(_ctx.$t('common.description')), 1)
          ])
        ]),
        _createVNode("div", _hoisted_14, [
          _createVNode("span", _hoisted_15, [
            _createVNode(_component_MultiSelect, {
              class: "kn-material-input",
              modelValue: _ctx.selectedOptions,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.selectedOptions = $event)),
              options: _ctx.driversManagemenDetailtDescriptor.options,
              optionLabel: "name",
              optionValue: "label",
              onChange: _ctx.changeType
            }, null, 8, ["modelValue", "options", "onChange"]),
            _createVNode("label", _hoisted_16, _toDisplayString(_ctx.$t('managers.driversManagement.options')), 1)
          ])
        ])
      ])
    ]),
    _: 1
  }))
}